import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'

import { muiTheme, emotionTheme } from './styles/theme'
import { GlobalStyles } from './styles/GlobalStyles'
import { queryClient } from './libs/queryClient'
import { Routers } from './routes'

import 'react-toastify/dist/ReactToastify.css'

function App() {
  return (
    <EmotionThemeProvider theme={emotionTheme}>
      <MuiThemeProvider theme={muiTheme}>
        <QueryClientProvider client={queryClient}>
          <ToastContainer />
          <GlobalStyles />
          <Routers />
        </QueryClientProvider>
      </MuiThemeProvider>
    </EmotionThemeProvider>
  )
}

export default App
